export const theme = {
  color: {
    white: "#FFFFFF",
    whisper: "#F5F5FA",
    mystic: "#E4E6F0",
    silver: "#C4C4C4",
    waterloo: "#7E839A",
    stormGrey: "#74788B",
    woodsmoke: "#18181B",
    mineShaft: "#333333",
    heater: "#BAC7D580",
    pattensBlue: "#D6E4FF",
    scienceBlue: "#0044CC",
    black: "#000000",
  },
  breakpoint: {
    laptop: "1480px",
    tablet: "1278px",
    tabletOne: "1120px",
    tabletTwo: "1045px",
    tabletPortrait: "990px",
    phone: "767px",
    phoneTwo: "700px",
    phonePortrait: "481px",
  },
} as const;
